import React, { useCallback, useEffect, useState } from "react";
import { getQuotesAPI } from "../../utils/APIs/quoteApis";
import QuoteTable from "./QuoteTable/QuoteTable";
import Loader from "../../Loader/Loader";
import QuoteChatTab from "./QuoteChatTab/QuoteChatTab";

const MyQuote = () => {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(() => {
    const savedPage = sessionStorage.getItem("chatPage");
    return savedPage ? Number(savedPage) : 1;
  });
  const [total, setTotal] = useState(0);
  const [activeTab, setActiveTab] = useState(() => {
    const savedTab = sessionStorage.getItem("myQuoteActiveTab");
    return savedTab ? savedTab : "quote";
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const stored = sessionStorage.getItem("isSidebarOpen");
    return stored !== null ? JSON.parse(stored) : true;
  });
  const LIMIT = 10;

  useEffect(() => {
    sessionStorage.setItem("myQuoteActiveTab", activeTab);
  }, [activeTab]);

  useEffect(() => {
    sessionStorage.setItem("chatPage", page);
  }, [page]);

  useEffect(() => {
    const interval = setInterval(() => {
      const stored = sessionStorage.getItem("isSidebarOpen");
      const parsed = stored !== null ? JSON.parse(stored) : true;

      if (parsed !== isSidebarOpen) {
        setIsSidebarOpen(parsed);
      }
    }, 10);

    return () => clearInterval(interval);
  }, [isSidebarOpen]);

  const mapQuotesResponse = (quotes = []) =>
    quotes.map((item) => ({
      id: item._id || "-",
      eventType: item.eventType || "-",
      eventDate: new Date(item.startDate).toLocaleDateString("en-IN") || "-",
      location: item.location || "-",
      duration: `${item.eventDuration} hrs` || "-",
      requirements: item.requirements && item.requirements.length > 0
                    ? item.requirements.map((r) => {
                        const labelMap = {
                          photos: "Photos",
                          reel: "Reel < 60sec",
                          video: "Video < 1 min",
                        };
                        return labelMap[r] || r;
                      }).join(", ")
                    : "-" || "-",
      budget: `₹${Number(item.budget).toLocaleString("en-IN")}` || "-",
      name: item?.clientName?.trim() || "-",
      quoteName: item?.clientName?.trim() || "-",
      currentBudget: item?.currentBudget || "-",
      previousBudget: item?.previousBudget || "-",
      flatOrHouseNo:item?.flatOrHouseNo || "-",
      streetName:item?.streetName || "-",
      city: item?.city || "-",
      postalCode:item?.postalCode || "-",
      state: item?.state || "-",
      phone: item?.clientId?.mobileNumber || "-",
      email: item?.clientId?.email || "-",
      status: item.quoteStatus || "-",
      startDate: item.startDate,
      endDate: item.endDate,
      eventDuration: item.eventDuration,
      editingPreferences: item.editingPreferences,
      additionalDetails: item.additionalDetails,
      serviceCategory: item.serviceCategory,
      quoteStatus: item.quoteStatus,
      requirementsList: item.requirements,
    }));


  const fetchQuotes = useCallback(async () => {
    setLoading(true); // 🔴 missing

    try {
      const res = await getQuotesAPI(page, 10);

      setQuotes(mapQuotesResponse(res?.data?.data));
      setTotal(res?.data?.meta?.total);
    } catch (err) {
      console.error("Quotes fetch failed", err);
    } finally {
      setLoading(false);
    }
 }, [page]);


 useEffect(() => {
  fetchQuotes();
}, [fetchQuotes]);

  const totalPages = Math.ceil(total / LIMIT);

  if (loading) return <Loader />;

  return (



    <div
      className={`content-container ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
      style={{ marginTop: "100px" }}
    >
      <div className="my-quote-page page-inner-wrapper">
        <h2 className="page-title">My Quote</h2>

        <div className="custom-tabs">
          <div
            className={`tab-item ${activeTab === "quote" ? "active" : ""}`}
            onClick={() => setActiveTab("quote")}
          >
            Quotes
          </div>

          <div
            className={`tab-item ${activeTab === "chat" ? "active" : ""}`}
            onClick={() => setActiveTab("chat")}
          >
            Chat
          </div>




        </div>

        {/* <QuoteTable data={quotes} /> */}
        {activeTab === "quote" && <QuoteTable data={quotes} page={page} limit = {LIMIT} fetchQuotes={fetchQuotes}/>}
        {activeTab === "chat" && <QuoteChatTab />}



       {activeTab === "quote" && total > LIMIT && (
          <div className="pagination">
            <button
              className="pagination-btn"
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
            >
              Prev
            </button>

            <span className="pagination-info">
              Page {page} of {totalPages}
            </span>

            <button
              className="pagination-btn"
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyQuote;
